export default __webpack_public_path__ + "static/media/background-parents-night.4f827cc6.jpg";